<template>
  <div class="home-page-toggle" v-if="isReady">
    <HomePageV2
      v-if="canUseNewPresenterHomepage"
      v-aha-emit-action.view
      name="homepageV2"
    />
    <HomePageOriginal
      v-else
      v-aha-emit-action.view
      name="homepageOriginal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import HomePageOriginal from '@/components-v2/home/HomePage.vue'
import HomePageV2 from '@/components-v2/home/HomePage.v2.vue'

export default {
  name: 'HomePageToggle',
  components: {
    HomePageOriginal,
    HomePageV2,
  },
  data() {
    return {
      isReady: false,
    }
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseNewPresenterHomepage']),
    ...mapState({
      currentUser: (state) => state.currentUser,
      presenterLocale: (state) => state.presenterLocale,
    }),
  },
  async mounted() {
    await this.initFeatureContext()
  },
  methods: {
    ...mapActions('featureToggles', ['initializeUserFeatureContext']),
    async initFeatureContext() {
      await this.initializeUserFeatureContext({
        currentUser: this.currentUser,
        presenterLanguage: this.presenterLocale,
      })
      this.isReady = true
    },
  },
}
</script>
